import { memo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import { aiChatShell } from '../../../styles/aiChatShell';

/**
 * メッセージアイテムコンポーネント（メモ化）
 */
const MessageItem = memo(({ message, index, isLastMessage, loading, purging, onEdit, showTurn }) => {
    if (message.role === "assistant" && (!message.content || message.content.trim() === "")) {
        return null;
    }

    const messageKey = message.id ? `${message.role}-${message.id}` : `msg-${index}`;
    const canEdit = message.role === "user" && !loading && !purging && !isLastMessage;
    // ターン表示は防災モデルの場合のみ（showTurnがtrueの場合のみ）
    const shouldShowTurn = showTurn && message.turn !== undefined;
    const isUser = message.role === "user";

    return (
        <div key={messageKey} className={isUser ? aiChatShell.msgUser : aiChatShell.msgAi}>
            {/* ヘッダー: ターン表示と編集ボタンを同じ行の左右に配置 */}
            {(shouldShowTurn || canEdit) && (
                <div className={aiChatShell.msgHeader}>
                    {shouldShowTurn && (
                        <div className={isUser ? aiChatShell.msgTurnBadgeUser : aiChatShell.msgTurnBadge}>
                            ターン {message.turn}
                        </div>
                    )}
                    {canEdit && (
                        <button
                            type="button"
                            className={isUser ? aiChatShell.msgEditButtonUser : aiChatShell.msgEditButton}
                            onClick={() => onEdit(message)}
                            title={`メッセージを編集${shouldShowTurn ? ` (ターン ${message.turn})` : ''}`}
                            aria-label="メッセージを編集"
                        >
                            <span className={aiChatShell.msgEditIcon} aria-hidden="true">edit</span>
                        </button>
                    )}
                </div>
            )}
            <div className={aiChatShell.msgContent}>
                {isUser ? (
                    <div className="whitespace-pre-wrap">{message.content}</div>
                ) : (
                    <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>
                        {message.content}
                    </ReactMarkdown>
                )}
            </div>
        </div>
    );
}, (prevProps, nextProps) => {
    // カスタム比較関数：必要なプロパティのみ比較
    return (
        prevProps.message.id === nextProps.message.id &&
        prevProps.message.content === nextProps.message.content &&
        prevProps.message.turn === nextProps.message.turn &&
        prevProps.loading === nextProps.loading &&
        prevProps.purging === nextProps.purging &&
        prevProps.isLastMessage === nextProps.isLastMessage &&
        prevProps.showTurn === nextProps.showTurn
    );
});

MessageItem.displayName = 'MessageItem';

export default MessageItem;
